import React, { useState, useEffect } from "react";
import { Card } from "../../../common/Card.jsx";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
// import { ReactComponent as Magnifier } from "../../../../assets/icons/Magnifier.svg";
// import { ReactComponent as PenIcon } from "../../../../assets/icons/pen.svg";
// import { ReactComponent as LockIcon } from "../../../../assets/icons/LockPassword.svg";
// import { ReactComponent as FilterIcon } from "../../../../assets/icons/dashboardFilterArrow.svg";
import { ReactComponent as SortIcon } from "../../../../assets/icons/dashboardSortArrow.svg";
import { formatDateToHumanReadable } from "../../../../utils/Helper.js";
import { useGetTrackCompanyListQuery, useGetUpdateViewedTimeMutation } from "../../../../store/Company/companyApiSlice.js";
// import { ReactComponent as DeleteIcon } from "../../../../assets/images/companyIcons/delete.svg";
// import tempCompanyIcon from "../../../../assets/icons/searchlisticon.png"

const EnterpriseActivityLogTable = () => {
  const location = useLocation();
  const { company, page, enterpriseID } = location.state || {};
  const { token } = useSelector((state) => state.auth);
  const [companyListed, setCompanyListed] = useState([]);
  const [activeMenu, setActiveMenu] = useState(null);
  const [sortingType, setSortingType] = useState('');
  const [getUpdateViewedTime] = useGetUpdateViewedTimeMutation();
  const { refetch } = useGetTrackCompanyListQuery({
    token,
    id: enterpriseID,
    page,
    limit: 9,
  }, {skip: !enterpriseID});

  useEffect(() => {
    const dataArray = company?.updates?.map(item => ({
      change_made: item?.content ?? "",
      dateTime: item?.timestamp ? formatDateToHumanReadable(item?.timestamp, "do MMMM yyyy, h:mm:ss a") : "",
      changeMadeBy: "",
      credentials: "",
      action: "...",
    }));
    setCompanyListed(dataArray)
  }, [company]);


  const updateViewedRequest = async () => {
    const response = await getUpdateViewedTime({
      token,
      id: company.id,
    });
    if(response){
      refetch();
    };
  }
  useEffect(() => {
    updateViewedRequest();
  }, [])

  // const editRole = (companyListed) => {
  // };

  // const changePassword = (companyListed) => {
  // };

  // const deleteAdmin = (companyListed) => {
  // };

  const onSortCompany = (type) => {
    let tempCompanyData;
    if (type == 'asc') {
      tempCompanyData = companyListed.slice().sort((a, b) => {
        if (a.change_made < b.change_made)
          return -1;
        if (a.change_made > b.change_made)
          return 1;
        return 0;
      });
    } else {
      tempCompanyData = companyListed.slice().sort((a, b) => {
        if (b.change_made < a.change_made)
          return -1;
        if (b.change_made > a.change_made)
          return 1;
        return 0;
      });
    }
    setSortingType(type);
    setCompanyListed(tempCompanyData);
  }
  return (
    <>
      <div className="text-left w-full font-bold text-[24px] text-primary mb-2">Activity Log</div>
      <div className="bg-white rounded-xl p-4">
        <Card classes="w-full md:col-start-1 md:col-end-10 flex justify-between">
          <div>
            {" "}
            <h3 className="text-left text-f20 text-primary font-bold">All Companies registered on the Platform</h3>
          </div>
          <div className="flex gap-2 pb-3">
            <div className="grid grid-cols-2 gap-2">
              <SortIcon className="h-10 w-auto p-1 border border-gray-300 rounded-md cursor-pointer" onClick={() => sortingType == 'asc' ? onSortCompany('desc') : onSortCompany('asc')} />
            </div>
          </div>
        </Card>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto bg-white rounded-lg">
            <thead className="justify-between">
              <tr className="h-14">
                <th className="px-2 py-2 border border-gray-300 text-left">
                  <span className="text-gray-500 text-sm">Changes Made</span>
                </th>
                <th className="px-2 py-2 border border-gray-300 text-left">
                  <span className="text-gray-500 text-sm">Date & Time</span>
                </th>
                {/* <th className="px-2 py-2 border border-gray-300">
                  <span className="text-gray-500 text-sm">Change Made By</span>
                </th>
                <th className="px-2 py-2 border border-gray-300">
                  <span className="text-gray-500 text-sm">Designation </span>
                </th> */}
                {/* <th className="px-2 py-2 border border-gray-300">
              <span className="text-gray-500 text-sm">Action</span>
            </th> */}
              </tr>
            </thead>
            <tbody className="bg-gray-200">
              {companyListed.map((companyListed, index) => (
                <tr key={index} className="bg-white h-20">
                  <td className="px-2 py-2 border border-gray-300 text-left">
                    <span className="text-gray-600 flex items-center justify-start flex-wrap gap-2">{companyListed.change_made}</span>
                  </td>
                  <td className="px-2 py-2 border border-gray-300 text-left">
                    <span className="text-gray-600">{companyListed.dateTime}</span>
                  </td>
                  {/* <td className="px-2 py-2 border border-gray-300 text-left">
                    <span className="text-gray-600">{companyListed.changeMadeBy}</span>
                  </td>
                  <td className="px-2 py-2 border border-gray-300 text-left">
                    <span className="text-gray-600">{companyListed.credentials}</span>
                  </td> */}
                  {/* <td className="px-2 py-2 border border-gray-300 text-left">
                <span className="text-gray-600">{companyListed.action}</span>
              </td>               */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default EnterpriseActivityLogTable;
